/**
 * Round 17 I16 -- "a, b and c" in the reader's language.
 *
 * Names joined with ", " read as English punctuation inside an Arabic
 * sentence, and the last item takes no "and"; the thread's holders,
 * what a function funds and the refusals' allowed actions were each
 * joined by hand. One formatter, the platform's, for every list of
 * names a sentence carries.
 */
import { i18n } from "shared/i18n";

export function listOf(
  items: readonly string[],
  type: "conjunction" | "disjunction" = "conjunction",
): string {
  const lang = i18n.language?.startsWith("ar") ? "ar" : (i18n.language ?? "en");
  try {
    return new Intl.ListFormat(lang, { style: "long", type }).format(items);
  } catch {
    return items.join(", ");
  }
}
